import { useSearchParams } from 'react-router-dom';

export function useWorkspaceIdFromParams() {
  const [searchParams] = useSearchParams();
  const workspaceId = searchParams.get('workspaceId');
  return workspaceId;
}
